import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AuthCallback } from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Directory from "@/pages/Directory";
import BusinessDetail from "@/pages/BusinessDetail";
import Dashboard from "@/pages/Dashboard";
import Feed from "@/pages/Feed";
import Admin from "@/pages/Admin";
import Discover from "@/pages/Discover";
import Network from "@/pages/Network";
import GoogleAuth from "@/pages/GoogleAuth";
import CategoriesIndex from "@/pages/CategoriesIndex";
import CategoryPage from "@/pages/CategoryPage";
import NewsList from "@/pages/NewsList";
import NewsArticle from "@/pages/NewsArticle";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function AppRouter() {
  const location = useLocation();
  // Process Google OAuth callback FIRST (synchronously) to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/google" element={<GoogleAuth />} />
      <Route path="/directory" element={<Directory />} />
      <Route path="/discover" element={<Discover />} />
      <Route path="/categories" element={<CategoriesIndex />} />
      <Route path="/categories/:slug" element={<CategoryPage />} />
      <Route path="/news" element={<NewsList />} />
      <Route path="/news/:slug" element={<NewsArticle />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/business/:id" element={<BusinessDetail />} />
      <Route path="/feed" element={<Feed />} />
      <Route path="/network" element={<ProtectedRoute><Network /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Helmet defaultTitle="IndiaBusinessCircle | India's Verified Business Network" titleTemplate="%s" />
      <BrowserRouter>
        <AppRouter />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
